import UserDto from '@/models/Users/UserDto';
import AddressDto from '@/models/CompanyAddresses/CompanyAddressDto';
import BaseAgencyScopeEntityDto from '@/models/Shared/BaseAgencyScopeEntityDto';
import PersonDto from '@/models/Shared/Person';
import GeoPoint from '@/models/Shared/GeoPoint';
import IAddressLine from '@/models/Shared/IAddressLine';
import Gender from '@/models/Shared/Gender';
import MaritalStatus from '@/models/Shared/MaritalStatus';
import IWorkerAvailability from '@/models/Workers/IWorkerAvailability';
import AvailabilityRestriction from '@/models/Workers/AvailabilityRestriction';
import AvailabilityRestrictionPeriod from '@/models/AvailabilityRestrictionPeriods/AvailabilityRestrictionPeriodDto';
import PositionDto from '@/models/Positions/PositionDto';
import WorkType from '@/models/Shared/WorkType';
import DeskDto from '@/models/Desks/DeskDto';
import BranchDto from '@/models/Branches/BranchDto';

export default class WorkerDto extends BaseAgencyScopeEntityDto implements IAddressLine, IWorkerAvailability {
    status = 0;
    legacyId: string;
    sequenceNumber = 0;
    person: PersonDto = new PersonDto();
    inviteCode = '';
    inviteSentAt: Date;
    userId: string;
    user: UserDto;
    buildingNameNumber = '';
    streetRoadBlock = '';
    locality = '';
    cityTown = '';
    stateProvinceRegion = '';
    postZipCode = '';
    countryCode = '';
    geometry: GeoPoint = new GeoPoint();
    isExactGeo: boolean;
    biography = '';
    summary = '';
    previousExperience = '';
    mobilePhoneNumber = '';
    otherPhoneNumber = '';  
    emailAddress = '';      
	dateOfBirth: Date               
	gender: Gender = Gender.Unknown;                 
	maritalStatus: MaritalStatus = MaritalStatus.Unknown;            
	nationality = "British";           
    nationalInsuranceNumber = '';  
    workTypes: WorkType[] = [];   
    isUnspentConvictions = false;
    convictionDetails = '';
    availability: string[] = [];
    availabilityRestriction: AvailabilityRestriction = AvailabilityRestriction.None;
    availabilityRestrictionPeriods: AvailabilityRestrictionPeriod[] = [];
    isDriver = false;
    maximumPassengers = 0;  
    isAgreedToMarketing = true; 
	emergencyContactName ='';  
    emergencyContactPhoneNumber ='';  
    payrollNumber ='';
    currentPositionId = '';
    currentPosition: PositionDto = new PositionDto();
    currentAnnualSalary = 0;
    desiredAnnualSalary = 0; 
    avatar = '';
    defaultDeskId: string;
    defaultDesk: DeskDto;
    defaultBranchId: string;
    defaultBranch: BranchDto;

    // Payroll send fields — used by the payroll adapter when pushing the
    // worker to the payroll system. Title / paymentMethod are universal;
    // uk_-prefixed fields hold HMRC-shaped values for UK payroll providers.
    // See TITLE_* / PAYMENT_METHOD_* / UK_* constants in api/core/workers.go.
    title = 0;          // TITLE_UNKNOWN
    paymentMethod = 1;  // PAYMENT_METHOD_BACS — DB default

    ukTaxCode = '';
    ukTaxCodeBasis = 0;        // UK_TAX_CODE_BASIS_UNKNOWN
    ukNiCategory = 0;          // UK_NI_CATEGORY_UNKNOWN
    ukStarterDeclaration = 0;  // UK_STARTER_DECLARATION_UNKNOWN
    ukStudentLoanPlan = 0;     // UK_STUDENT_LOAN_PLAN_NONE

    // Holiday snapshot — latest data pulled from the payroll system.
    // Overwritten on every successful payslip pull (no history).
    holidayAvailableUnits = 0;
    holidayTakeInDays = true;
    holidayAccruedThisYear = 0;
    holidayTakenThisYear = 0;
    holidayPaidThisYear = 0;  // pence
    holidayAccrualRate = 0;
    externalPayrollSystemHolidaySchemeId = '';
    holidaySchemeName = '';
    // Pence — the rate the available holiday balance would be paid at.
    holidayAvailablePayRate = 0;
    holidayAvailablePay = 0;
    holidayLastPulledAt: string | null = null;
    holidayLastPulledPayrollRunId: string | null = null;

	// bankAccountName: string ='';
    // bankAccountSortCode: string ='';
    // bankAccountNumber: string ='';
    
    get isAvailableMonAM() {
        return this.availability.includes("MonAM");
    }

    get isAvailableMonPM() {
        return this.availability.includes("MonPM");
    }

    get isAvailableTueAM() {
        return this.availability.includes("TueAM");
    }

    get isAvailableTuePM() {
        return this.availability.includes("TuePM");
    }

    get isAvailableWedAM() {
        return this.availability.includes("WedAM");
    }

    get isAvailableWedPM() {
        return this.availability.includes("WedPM");
    }

    get isAvailableThuAM() {
        return this.availability.includes("ThuAM");
    }

    get isAvailableThuPM() {
        return this.availability.includes("ThuPM");
    }

    get isAvailableFriAM() {
        return this.availability.includes("FriAM");
    }

    get isAvailableFriPM() {
        return this.availability.includes("FriPM");
    }

    get isAvailableSatAM() {
        return this.availability.includes("SatAM");
    }

    get isAvailableSatPM() {
        return this.availability.includes("SatPM");
    }

    get isAvailableSunAM() {
        return this.availability.includes("SunAM");
    }

    get isAvailableSunPM() {
        return this.availability.includes("SunPM");
    }
}